// Components
import { addToast } from "../../components/toasts";

// Models
import { KillerQuestionAnswer } from "../../models/killer-question-answer";

// Resources
import { GENERAL_ERROR, GENERAL_ERROR_SUPPORT_MODE } from "../../resources";
import { catchError } from "../../catchErrors";

// Settings
import { POST_KQ_URL } from "./settings";

// Requests
import { getKillerQuestions } from "./requests";
import { enableSubscribeOfferButton, finishKillerQuestionsModal, onCloseModalExperiences, onCloseModalFormations, onCloseModalKillerQuestions, stepper } from "./offer-detail";
import { addModalCloseCallback, closeModal, closeSpecificModal, removeModalCloseCallback, showModal, EuiModalSize } from "../../components/modal";

const offerTitle = () => $("#offerDetailSettings").attr("data-OFFER_TITLE")!;
const offerDescription = () => $("#offerDetailSettings").attr("data-OFFER_LOCATION")!;
const applyOfferModal = () => $("#applyOfferModal");
let killerQuestions: string;

export async function getHaveKillerQuestions(): Promise<boolean> {
  try {
    killerQuestions = await getKillerQuestions();
    $("[killer-questions-form").remove();
    $("#applyOfferStepper").append(killerQuestions);
    return killerQuestions !== '';
  } catch(error) {
    catchError(error);
    return false;
  }
}

export async function showKillerQuestionsModal() {
  $("#applyOfferStepper [prev-step]").on("click", () => {
    stepper.prev();
  });

  const questionsIds: number[] = JSON.parse(
    atob($("#killerQuestionsIds").attr("data-ids")!)
  );

  const rules: JQueryValidation.RulesDictionary = {};
  questionsIds.forEach((id: number) => {
    // @ts-ignore
    rules[id.toString()] = { required: true };
  });
  const questionsSteps: number = $("[killer-questions-form]").length;

  $("#experienceOfferTitle").text(offerTitle());
  $("#experienceOfferLocation").text(offerDescription());

  $("[killer-questions-form]").each(
    (index: number, formElement: HTMLElement) => {
      $(formElement).validate({
        rules: rules,
        errorPlacement: () => {
          return true;
        },
        submitHandler: () => {
          if (questionsSteps - 1 === index) {
            sendKillerQuestions();
          } else {
            stepper.next();
          }
        },
      });
    }
  );

  removeModalCloseCallback('#applyOfferModal', onCloseModalExperiences);
  removeModalCloseCallback('#applyOfferModal', onCloseModalFormations);
  removeModalCloseCallback('#applyOfferModal', onCloseModalKillerQuestions);
  addModalCloseCallback('#applyOfferModal', onCloseModalKillerQuestions);

  showModal('#applyOfferModal', { isFullScreen: true, overlayClose: false, size: EuiModalSize.S });
  window.dataLayer?.push({
    event: "PedirKillerQuestionsOferta",
  });
}

function sendKillerQuestions(): void {
  $("#sendKillerQuestions").prop("disabled", true);

  const answers: KillerQuestionAnswer[] = [];
  const questionsIds: number[] = JSON.parse(
    atob($("#killerQuestionsIds").attr("data-ids")!)
  );

  questionsIds.forEach((id: number) => {
    const answer = $(`#applyOfferStepper [name="${id}"]`);

    if (answer.length > 1) {
      answers.push({
        idQuestion: id,
        answer: "",
        selectedAnswer: +answer.filter(":checked").val()!,
      });
    } else {
      answers.push({
        idQuestion: id,
        answer: answer.val()!.toString(),
        selectedAnswer: null,
      });
    }
  });

  $.ajax({
    type: "POST",
    url: POST_KQ_URL,
    data: JSON.stringify(answers),
    contentType: "application/json",
  })
    .done(() => {
      applyOfferModal().off('hidden.bs.modal', enableSubscribeOfferButton);
      closeSpecificModal('#applyOfferModal');
      finishKillerQuestionsModal();
    })
    .fail((x) => {
      if (x.status == 412) addToast(GENERAL_ERROR_SUPPORT_MODE, "info");
      else addToast(GENERAL_ERROR);
    })
    .catch(catchError)
    .always(() => {
      $("#sendKillerQuestions").prop("disabled", false);
    });
}
